<template>
  <div>
    <CardedSectionHeader
      icon="mdi-form-select"
      label="News Letter Subscription"
      id="admin_view_newsletter_subscription_details"
    ></CardedSectionHeader>
    <div class="pt-4 pb-4 white text-right pr-8">
      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        color="red"
        v-if="parseInt(news_letter_subscription.is_active) == 1"
        @click="update_status(0)"
        :disabled="is_loading"
      >
        <v-icon left>mdi-pen</v-icon>Disable Subscription
      </v-btn>

      <v-btn
        small
        rounded
        class="mr-4"
        outlined
        color="success"
        v-else
        @click="update_status(1)"
        :disabled="is_loading"
      >
        <v-icon left>mdi-pen</v-icon>Enable Subscription
      </v-btn>
    </div>
    <CardedDisplay>
      <ViewHeader
        :title="news_letter_subscription.email_address"
        :icon="'mdi-mail'"
        :img_src="'https://res.cloudinary.com/solidcare-img-cloud/image/upload/v1606683118/botswana%20services/website%20assets/newsletter_amaevv.jpg'"
        :facts="view_header_facts"
        :description="''"
      ></ViewHeader>
    </CardedDisplay>
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import CardedSectionHeader from "../../../components/CardedSectionHeader";
import CardedDisplay from "../../../components/CardedDisplay";
import CardedTable from "../../../components/CardedTable";
import ViewHeader from "../../../components/ViewHeader";
import ServerClient from "../../../lib/ServerClient";
export default {
  name: "AdminCategoriesView",
  components: {
    CardedSectionHeader,
    CardedDisplay,
    ViewHeader,
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      news_letter_subscription: {
        id: 0,
        email_address: "",
        is_active: 0,
        date_expired: "",
        date_expired_timestamp: 0,
      },
    };
  },
  computed: {
    view_header_facts() {
      var facts = [
        {
          text: "Status:",
          val:
            parseInt(this.news_letter_subscription.is_active) == 1
              ? "Active"
              : "Disabled",
        },
        {
          text: "Date Expired:",
          val:
            this.news_letter_subscription.date_expired == "1989-01-01"
              ? "still active"
              : this.news_letter_subscription.date_expired,
        },
      ];
      return facts;
    },
  },
  methods: {
    load_item() {
      var sub_id = this.$route.params.id;
      this.$emit("on-show-loader");
      ServerClient.NewsLetterSubscriptions.get_news_letter_subscription(
        {
          id: sub_id,
        },
        (res) => {
          this.$emit("on-hide-loader");
          this.news_letter_subscription = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading news letter subscriptions details on admin",
            errors
          );
        }
      );
    },
    update_status(status) {
        
        var update = {
            id: this.$route.params.id,
            is_active: status
        };
        if(status == 1){ //active
            update.date_expired = "1989-01-01";
            update._time_date_expired_timestamp = update.date_expired;
        }else{
            update._date_date_expired = "";
            update._now_date_expired_timestamp = "";
        }
      
        this.$emit("on-show-loader");
        ServerClient.NewsLetterSubscriptions.update_news_letter_subscription(
            update,
            (res) => {
                this.$emit("on-hide-loader");
                console.log("Updating subscription success", res);
                this.load_item();
            },
            (errors) => {
                this.$emit("on-hide-loader");
                console.log(
                    "Errors while updating news letter subscriptions details on admin",
                    errors
                );
            }
        );
    },
  },
  mounted() {
    var sub_id = this.$route.params.id;
    this.$emit("set-page-attributes", {
      title: "News Letter Subscription Details",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "News Letters",
          disabled: false,
          href: "/admin/new_letters",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/new_letters/list",
        },
        {
          text: "View",
          disabled: true,
          href: "/admin/new_letters/list/view/" + sub_id,
        },
      ],
    });
    this.load_item();
  },
};
</script>

<style scoped>
.thumb_div {
  background-color: grey;
  height: 200px;
  width: 200px;
}

.view-title {
  font-size: 18px;
  text-align: center;
  font-weight: bold;
}

.view-label {
  /* font- */
}

.view-description-content {
  background-color: #cccccc24;
  height: 80px;
  border-radius: 10px;
  font-size: 16px;
  text-align: left;
  padding: 10px;
  color: #000000c7;
}
</style>